// The one place a secret is ever shown (spec/dashboard.md section 12.4; spec/api-conventions.md section 2: write-only
// afterwards, the prefix and the hint are all a listing has). A dialog with Copy that says so; closing it is final.
import { useState, type ReactNode } from 'react';
import { Button } from '../../ui/Button';
import { AlertTriangle, Check, Copy } from '../../ui/icons';
import { Modal } from '../../ui/Modal';
import { useToasts } from '../../ui/Toast';
import '../org/org.css';

export function SecretOnce({ open, title = 'Your new key', label = 'The key', secret, hint, note, onClose }: { open: boolean; title?: string; label?: string; secret: string; hint?: string; note?: ReactNode; onClose: () => void }) {
  const toasts = useToasts();
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
      toasts.success('Copied to the clipboard.');
    } catch {
      toasts.error('Could not copy; select the key and copy it by hand.');
    }
  };
  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      initialFocus="none"
      footer={
        <>
          <Button onClick={() => void copy()} variant="primary" icon={copied ? <Check aria-hidden="true" /> : <Copy aria-hidden="true" />}>
            Copy
          </Button>
          <Button onClick={onClose}>{copied ? 'Done' : 'I have saved it'}</Button>
        </>
      }
    >
      <div className="secret-once" data-testid="secret-once">
        <div className="banner banner-warning" role="note">
          <AlertTriangle className="banner-icon" aria-hidden="true" />
          <div className="banner-body">
            This is the only time the {label.toLowerCase()} is shown. Store it now; afterwards only its prefix and last four characters are visible{hint ? ` (…${hint})` : ''}.
          </div>
        </div>
        <div className="pane pane-highlight secret-pane">
          <div className="pane-body">
            <div className="field-label">{label}</div>
            <code className="secret-value secret-text" data-testid="secret-value">
              {secret}
            </code>
          </div>
        </div>
        {note}
      </div>
    </Modal>
  );
}
